module.exports = __webpack_public_path__ + "img/bd-summon-nec.0582531f.png";